<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section operations" style="height: 39px;">
        <div class="triggers">
          <div>
            <span style="display: inline-block;width: 50px;color: #333333">{{ $t('common.btn.query') }}</span>
            <el-input
              v-model="searchConditions.likeName"
              no="likeName"
              style="width: 286px;"
              :placeholder="$t('common.tips.fuzzySearch')"
              @change="searchConditions.pageNum=1"
              @keyup.enter.native="fetchAirPortList"
            />
            <el-button no="query" type="primary" size="mini" @click="fetchAirPortList">{{ $t('common.btn.query') }}</el-button>
            <el-button v-permission="['write_SMAirPort']" no="new" type="primary" size="mini" @click="popAirPortAddDialog">{{
              $t('common.btn.new') }}
            </el-button>
            <el-button v-permission="['write_SMAirPort']" no="edit" type="primary" size="mini" @click="popAirPortEditFormDialog">{{
              $t('common.btn.edit') }}
            </el-button>
            <el-button v-permission="['write_SMAirPort']" no="delete" type="danger" size="mini" @click="toBatchDel">{{
              $t('common.btn.delete') }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="100201"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="searchConditions.total>0"
          config-module="1002011"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchAirPortList"
        />
      </div>
    </div>

    <!-- 添加基础港口 -->
    <el-dialog
      v-if="airPortAddListDialog.isShow"
      v-el-drag-dialog
      :visible.sync="airPortAddListDialog.isShow"
      :close-on-click-modal="false"
      :title="$t('baseInfo.airport.addBasePort')"
      class="add-basic-seaport"
      :modal-append-to-body="false"
      width="800px;"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px">
        <div class="filters">
          <el-form :inline="true" label-width="50px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item
                :label="$t('CargoMsg.Cargo_Query')"
                :error="airPortAddListDialog.searchLikeName.length>=2?'':$t('Message.PleaseEnter')"
                :show-message="false"
              >
                <el-input
                  v-model="airPortAddListDialog.searchLikeName"
                  no="searchLikeName"
                  style="width: 260px"
                  size="mini"
                  :placeholder="$t('Message.PleaseEnterTheCode2')"
                  @keyup.enter.native.prevent="toLoadTemplatePort"
                />
              </el-form-item>
              <el-button no="query2" size="mini" type="primary" @click="toLoadTemplatePort">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="app-main-inner-row row-grid-dialog">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="airPortAddListDialog.gridOptions"
          :column-defs="airPortAddListDialog.columnDefs"
          :row-data="airPortAddListDialog.rowData"
          style="width:100%;height: 300px"
          @gridReady="onSeaportAddListDialogReady"
        />
      </div>
      <div slot="footer">
        <el-button no="confirm" type="primary" size="mini" @click="toAddTemplatePortToPortList">{{ $t('common.btn.confirm') }}
        </el-button>
        <el-button no="cancel" size="mini" @click="toCancelTemplateChoose">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 港口新增或维护 -->
    <el-dialog
      v-if="isShowPortMaintain"
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowPortMaintain"
      :title="portMaintainTitle"
      inline-message
      :modal-append-to-body="false"
      width="350px"
    >
      <el-form ref="amsPortForm" :model="airPortForm" label-width="90px" label-position="left">
        <el-form-item :label="$t('baseInfo.airport.serialNumber')" prop="serialNumber">
          <el-input-number
            v-model="airPortForm.serialNumber"
            no="serialNumber"
            :min="1"
            :max="999999"
            size="mini"
            style="width: calc(50% - 50px);"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.airport.code')" prop="code" required>
          <el-input v-model="airPortForm.code" no="code" :disabled="!platformTenant" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.airport.chineseName')" prop="chineseName">
          <el-input v-model="airPortForm.chineseName" no="chineseName" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.airport.englishName')" prop="englishName" required>
          <el-input v-model="airPortForm.englishName" no="englishName" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.airport.interchangeCode')" prop="interchangeCode">
          <el-input v-model="airPortForm.interchangeCode" no="interchangeCode" :disabled="!platformTenant" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.airport.isoCode')" prop="isoCode">
          <el-input v-model="airPortForm.isoCode" no="isoCode" :disabled="!platformTenant" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CountryRegion')" prop="countryCode">
          <cargo-advance-select
            no="countryCode"
            :select-type="selectTypeNames.basic_data_Country"
            :callback-params="{key:'countryCode'}"
            callback-method-type="value"
            :default-value="airPortForm.countryCode"
            filterable
            style="width:240px;"
            @parentCallBack="getValueFromChild"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.airport.region')">
          <cargo-advance-select
            no="region"
            filterable
            :select-type="selectTypeNames.basic_data_Region"
            :callback-params="{key:'code'}"
            callback-method-type="value"
            :default-value="airPortForm.region"
            style="width:240px;"
            @parentCallBack="airPortForm.region=$event.value"
          >
            <template slot-scope="{option:{item,fields}}">
              <div style="display: flex;justify-content: space-between;width:400px;">
                <div v-for="(field) in fields" :key="field" style="width:30%">{{ item[field] }}</div>
              </div>
            </template>
          </cargo-advance-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
          <el-input v-model="airPortForm.cityName" no="cityName" disabled style="width: 170px" />
          <el-button no="cityClickHandler" type="primary" style="margin-left: 5px" @click="cityClickHandler">...</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button no="save" size="mini " type="primary" @click="submitAirPort">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel2" size="mini " @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <location-search-dialog
      :visible.sync="cityDialogVisible"
      @addCallBack="selectLocalHandler"
      @close="cityDialogVisible=false"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import CountrySelector from '@/components/Cargo/CountrySelector'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import { getCountryList } from '@/api/country'
import { getAllRegionList } from '@/api/basicData/region'
import {
  addPlatformPort,
  addTemplatePort2Tenant,
  batchDelAirPort,
  getAirPortList,
  loadTemplatePort,
  updateAirPort
} from '@/api/airport'
import { getUserInfo } from '@/utils/auth'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocationSearchDialog from '@/views/cargo/v0/Information/components/LocationSearchDialog'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'APort',
  components: { CountrySelector, cargoAdvanceSelect, LocationSearchDialog },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      operationType: '',
      searchConditions: {
        likeName: '',
        pageNum: 1,
        pageSize: 10,
        total: 4
      },
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        }
      },
      gridParams: {},
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.airport.serialNumber'),
          field: 'serialNumber',
          width: 80
        }, {
          headerName: this.$t('baseInfo.airport.code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('baseInfo.airport.englishName'),
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.airport.chineseName'),
          field: 'chineseName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryCode',
          width: 100,
          cellRenderer: (params) => {
            const country = this.countryList.find(item => {
              return item.code === params.value
            })
            return country ? country.name : params.value
          }
        }, {
          headerName: this.$t('baseInfo.airport.cityCode'),
          field: 'cityCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.airport.cityName'),
          field: 'cityName',
          width: 100
        }, {
          headerName: this.$t('baseInfo.airport.region'),
          field: 'region',
          width: 100,
          cellRenderer: (params) => {
            const region = this.regionList.find(item => {
              return item.code === params.value
            })
            return region ? region.name : params.value
          }
        }, {
          headerName: this.$t('baseInfo.airport.interchangeCode'),
          field: 'interchangeCode',
          width: 150
        }, {
          headerName: this.$t('baseInfo.airport.isoCode'),
          field: 'isoCode',
          width: 150
        }],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      reversalCountryObj: {},
      isShowPortMaintain: false,
      portMaintainTitle: this.$t('baseInfo.airport.portAdd'),
      airPortForm: {
        uuid: '',
        serialNumber: 1,
        code: '',
        chineseName: '',
        englishName: '',
        cityName: '',
        cityCode: '',
        interchangeCode: '',
        isoCode: '',
        countryCode: '',
        region: '',
        version: ''
      },
      initAirPortForm: {
        uuid: '',
        serialNumber: '',
        code: '',
        chineseName: '',
        englishName: '',
        cityName: '',
        cityCode: '',
        interchangeCode: '',
        isoCode: '',
        countryCode: '',
        region: ''
      },
      airPortAddListDialog: {
        searchLikeName: '',
        isShow: false,
        gridOptions: {
          rowClassRules: {
            'grid-row-zebra-even': function(params) {
              return !(params.rowIndex % 2)
            },
            'grid-row-zebra-odd': function(params) {
              return (params.rowIndex % 2)
            }
          },
          rowSelection: 'multiple',
          suppressCellSelection: true,
          isRowSelectable: function(row) {
            return row.data && !row.data.isExistPort
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          paginationPageSize: 500,
          paginationNumberFormatter: function(params) {
            return '[' + params.value.toLocaleString() + ']'
          }
        },
        columnDefs: [
          {
            headerName: '', width: 60, checkboxSelection: params => {
              return !params.data.isExistPort
            },
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('baseInfo.airport.whetherToAdd'),
            field: 'isExistPort',
            cellRenderer: params => {
              const iconName = !params.data.isExistPort ? 'grid-icon-enabled' : 'grid-icon-disabled'
              const color = params.data.isExistPort ? '#67c23a' : '#e6a23c'
              return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
            },
            width: 130
          },
          {
            headerName: this.$t('baseInfo.airport.serialNumber'),
            field: 'serialNumber',
            width: 80
          }, {
            headerName: this.$t('baseInfo.airport.code'),
            field: 'code',
            width: 100
          }, {
            headerName: this.$t('baseInfo.airport.chineseName'),
            field: 'chineseName',
            width: 150
          }, {
            headerName: this.$t('baseInfo.airport.englishName'),
            field: 'englishName',
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
            field: 'countryCode',
            width: 100,
            cellRenderer: (params) => {
              const country = this.countryList.find(item => {
                return item.code === params.value
              })
              return country ? country.name : params.value
            }
          }, {
            headerName: this.$t('baseInfo.airport.cityCode'),
            field: 'cityCode',
            width: 150
          }, {
            headerName: this.$t('baseInfo.airport.cityName'),
            field: 'cityName',
            width: 150
          }, {
            headerName: this.$t('baseInfo.airport.region'),
            field: 'region',
            width: 100,
            cellRenderer: (params) => {
              const region = this.regionList.find(item => {
                return item.code === params.value
              })
              return region ? region.name : params.value
            }
          }, {
            headerName: this.$t('baseInfo.airport.interchangeCode'),
            field: 'interchangeCode',
            width: 100
          }, {
            headerName: this.$t('baseInfo.airport.isoCode'),
            field: 'isoCode',
            width: 100
          }],
        rowData: [],
        gridApi: null
      },
      fullscreenLoading: null,
      countryList: [],
      regionList: [],
      cityDialogVisible: false,
      loading: null
    }
  },
  computed: {
    url() {
      return URL
    },
    platformTenant() { // 是否平台维护
      return getUserInfo() && getUserInfo().tenantId === 1
    }
  },
  mounted() {
    this.fetchAirPortList()
  },
  methods: {
    onGridReady(params) {
    },
    onSeaportAddListDialogReady(params) {
      const self = this
      // window.addEventListener('resize', function() {
      //   setTimeout(function() {
      //     self.onFirstDataRendered(self.airPortAddListDialog.gridOptions)
      //   })
      // })
    },
    // 获取国家列表
    fetchCountryList() {
      const self = this
      getCountryList().then(res => {
        if (res.data.length > 0) {
          const reversal = {}
          res.data.map(item => {
            reversal[item.chineseName] = item.code
            return item
          })

          self.reversalCountryObj = reversal
        }
      })
    },
    // 获取空运港口列表
    fetchAirPortList() {
      const self = this
      self.fullscreenLoading = getLoading()
      const params = { ...this.searchConditions }
      Promise.all([getAirPortList(params), getCountryList(), getAllRegionList()]).then(results => {
        const res = results[0]
        this.countryList = results[1].data
        this.regionList = results[2].data
        self.rowData = res.data.list
        self.searchConditions.pageNum = res.data.pageNum
        self.searchConditions.pageSize = res.data.pageSize
        self.searchConditions.total = Number(res.data.total)
        self.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 增加模板港口到 港口列表
    toAddTemplatePortToPortList() {
      // 校验是否 已存在
      const choosePorts = getGridSelected(this.airPortAddListDialog.gridOptions)
      if (choosePorts.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }

      const saveList = []
      choosePorts.forEach(port => {
        if (!port.isExistPort) {
          saveList.push({
            code: port.code,
            isBasePort: port.isBasePort,
            englishName: port.englishName,
            chineseName: port.chineseName,
            countryCode: port.countryCode,
            region: port.region,
            cityName: port.cityName,
            cityCode: port.cityCode,
            interchangeCode: port.interchangeCode,
            isoCode: port.isoCode
          })
        }
      })

      if (saveList.length > 0) {
        addTemplatePort2Tenant(saveList).then(res => {
          this.airPortAddListDialog.isShow = false
          this.$message.success(this.$t('common.tips.saveSuccess'))
          this.fetchAirPortList()
        }).catch(() => {
        })
      }
    },
    toCancelTemplateChoose() {
      this.airPortAddListDialog.isShow = false
    },
    popAirPortAddDialog() {
      // 新增弹窗 ，需要根据租户区分(tenantId==1 平台维护，tenantId=其他的)
      if (this.platformTenant) {
        this.popAirPortAddFormDialog()
      } else {
        this.popAirPortAddListDialog()
      }
    },
    // 其他客户新增弹窗
    popAirPortAddFormDialog() {
      this.airPortForm = { ...this.initAirPortForm }
      this.airPortForm.isEdit = false
      this.isShowPortMaintain = true
    },
    // 新增列表弹窗
    popAirPortAddListDialog() {
      this.airPortAddListDialog.isShow = true
      this.airPortAddListDialog.rowData = []
      this.airPortAddListDialog.searchLikeName = ''
    },
    toLoadTemplatePort() {
      if (this.airPortAddListDialog.searchLikeName.length >= 2) {
        this.loading = getLoading4Cxt()
        loadTemplatePort(this.airPortAddListDialog.searchLikeName).then(res => {
          // 平台多有港口
          const portList = res.data.platform
          // 当前租户所拥有的港口
          const currentPortList = res.data.current
          portList.forEach(port => {
            port.isExistPort = false
            currentPortList.forEach(currentPort => {
              if (currentPort.code === port.code) {
                port.isExistPort = true
                return
              }
            })
          })
          this.airPortAddListDialog.rowData = [...portList]
        }).catch().finally(() => {
          this.loading.close()
        })
      }
    },
    // 编辑弹窗
    popAirPortEditFormDialog() {
      const self = this
      self.portMaintainTitle = this.$t('baseInfo.airport.portEdit')
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          this.$message.error(this.$t('common.tips.hasOneAtleast'))
        } else {
          console.log('getGridSelected(this.gridOptions)', getGridSelected(this.gridOptions)[0])
          self.airPortForm = { ...getGridSelected(this.gridOptions)[0] }
          if (this.platformTenant) {
            self.airPortForm.isEdit = false
          } else {
            self.airPortForm.isEdit = true
          }
          self.isShowPortMaintain = true
        }
      })
    },
    toBatchDel() {
      const self = this
      const airArray = this.getAirPortSelected()
      if (airArray) {
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          batchDelAirPort(airArray).then(res => {
            self.fetchAirPortList()
            this.$message({
              type: 'success',
              message: this.$t('common.tips.deleteSuccess')
            })
          }).catch(() => {
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.tips.cancelDelete')
          })
        })
      }
    },
    getAirPortSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return null
      }
      return selectedRows
    },
    // 校验空运非空表单
    toCheckAirPortForm(opt) {
      const { code, englishName } = { ...this.airPortForm }
      let errorMsg = ''
      if (!code) {
        errorMsg += ' ' + this.$t('baseInfo.airport.codeCheck')
      }
      if (!englishName) {
        errorMsg += ' ' + this.$t('baseInfo.airport.englishNameCheck')
      }
      if (errorMsg) {
        this.$message.error(errorMsg)
        return
      } else {
        return true
      }
    },
    // 编辑空运港口
    editAirPort() {
      this.fullscreenLoading = getLoading()
      updateAirPort(this.airPortForm).then(res => {
        this.isShowPortMaintain = false
        this.fullscreenLoading.close()
        this.$message({ message: this.$t('common.tips.editSuccess'), type: 'success' })
      }).then(() => {
        this.fetchAirPortList()
      }).catch(err => {
        this.fullscreenLoading.close()
      })
    },
    // 新增空运港口
    toAddPlatformPort() {
      addPlatformPort(this.airPortForm).then(res => {
        this.isShowPortMaintain = false
        this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
      }).then(() => {
        this.fetchAirPortList()
      })
    },
    // 平台用户新增空运或客户编辑空运港口
    submitAirPort() {
      if (!this.toCheckAirPortForm()) {
        return
      }
      if (this.platformTenant) {
        this.toAddPlatformPort()
      } else {
        this.editAirPort()
      }
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.isShowPortMaintain = false
      this.airPortForm = {}
    },
    getValueFromChild(obj) {
      this.airPortForm[obj.key] = obj.value
    },
    cityClickHandler() {
      this.cityDialogVisible = true
    },
    selectLocalHandler(location) {
      this.airPortForm.cityName = location.englishName
      this.airPortForm.cityCode = location.code
    }
  }
}
</script>

<style scoped lang="scss">
.add-basic-seaport ::v-deep {
  .ag-paging-page-summary-panel  {
    display: flex;
  }
}
</style>
